<template>
  <div class="RichText">
    <h3
      class="RichText-title"
    >
      {{TLang('商品详情','list')}}
    </h3>
    <div
      v-if="propertyInfoList && propertyInfoList.length > 0"
      class="propertyInfo clearfix"
    >
      <div
        v-for="item in propertyInfoList"
        :key="item.specName"
        :class="{
          'propertyList': true,
          'fl': true,
          'wideItem': item.specName.indexOf('品牌') > -1,
        }"
      >
        <span class="propertyLabel">
          {{ item.specName }}：
        </span>
        <span
          class="propertyName"
          v-if="item.specValues && item.specValues.length > 0"
        >
          <span
            v-for="(info, infoIndex) in item.specValues"
            :key="infoIndex"
          >
            {{ info }}<span v-if="infoIndex < item.specValues.length - 1">、</span>
          </span>
        </span>
      </div>
    </div>
    <div
      v-if="imgListTop.length>0"
      :style="{marginTop: '16px'}"
    >
      <AdviseBanner :imgList="imgListTop" />
    </div>
    <img
      class="fpp-rules-img"
      v-if="jphProductDescUrl"
      :src="jphProductDescUrl"
      alt=""
    />
    <div
      v-if="warmReminder"
      class="nice-tip"
    >
      <p class="nice-tip-title">
        {{TLang('温馨提示','address')}}
      </p>
      <p class="nice-tip-subtitle">
        NICE REMINDER
      </p>
      <p class="nice-tip-content">
        {{ warmReminder }}
      </p>
    </div>
    <div
      v-for="item in goodsDescriptionList"
      :key="item.id"
      class="segment"
      v-html="item.content"
    ></div>
    <div v-if="imgListBottom.length>0">
      <AdviseBanner :imgList="imgListBottom" />
    </div>
    <div v-if="imgSales != null">
      <AfterSalesPolicy :imgSales="imgSales" />
    </div>
  </div>
</template>

<script>
import AdviseBanner from './../AdviseBanner';
import AfterSalesPolicy from './../AfterSalesPolicy';
export default {
  name: 'RichText',
  components: { AdviseBanner, AfterSalesPolicy},
  props: {
    propertyInfoList: Array,
    goodsDescriptionList: Array,
    warmReminder: String,
    jphProductDescUrl: String,
    imgListTop: Array,
    imgListBottom: Array,
    imgSales:String,
  },
};
</script>

<style lang="less" scoped>
.RichText{
  // margin-top: 70px;
  flex: 1;
  .segment{
    // padding: 20px 48px;
    padding: 0px 48px;
  }
  &-title {
    font-size: 24px;
    color: #333333;
    border-bottom: 1px solid #b2b2b2;
    line-height: 50px;
  }
  .fpp-rules-img {
    display: block;
    margin: 30px auto;
    width: 790px;
  }
  .nice-tip {
    margin: 30px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    text-align: center;
    &-title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 45px;
    }
    &-subtitle {
      font-size: 14px;
      color: rgba(222, 222, 222, 1);
      line-height: 16px;
    }
    &-content {
      width: 800px;
      margin: 5px auto;
      padding-bottom: 20px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 26px;
      white-space: wrap;
      text-align: justify;
    }
  }
}
</style>
<style lang="less" scoped>
  .propertyInfo {
    width: 100%;
    color: #6D7278;
    padding: 32px 48px 14px;
    box-sizing: border-box;
    .propertyList {
      width: 33%;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
    
      margin-bottom: 16px;
      padding-right: 8px;
      box-sizing: border-box;
    }
    .wideItem {
      width: 100%;
      margin-bottom: 24px;
      .propertyName {
        font-weight: 700;
        // font-family: PingFangSC-Medium, PingFang SC;
      }
    }
  }



  .clearfix {
    zoom: 1;
  }
  .clearfix:after {
      content: ' ';
      display: block;
      height: 0;
      font-size: 0;
      clear: both;
      visibility: hidden;
  }
  .fl {
      float: left;
  }
  .fr {
      float: right;
  }
</style>

<style>
.segment img {
  max-width: 790px;
  margin: 0 auto;
  display: block;
  /* transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  position: relative;
  left: 50%;
  vertical-align: top; */
}
</style>